var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-w-100"},[(_vm.files.length > 0)?_c('div',_vm._l((_vm.files),function(file){return _c('div',{key:file.id},[_vm._v(" "+_vm._s(file.filename)+" ")])}),0):_c('div',[_vm._v("-")])])}
var staticRenderFns = []

export { render, staticRenderFns }